module.exports = __webpack_public_path__ + "static/img/footer_wecode_3.1cd3f38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer_wecode_3.jpg
// module id = 7t0B
// module chunks = 29